import { MapContainer, TileLayer, Marker, Popup, Circle, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useMemo } from "react";

// Custom marker SVG generator
function makeIcon(color, pulse = false) {
  const svg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' width='34' height='44' viewBox='0 0 34 44'>
  <defs>
    <filter id='s' x='-40%' y='-20%' width='180%' height='160%'>
      <feDropShadow dx='0' dy='2' stdDeviation='2' flood-color='rgba(14,27,42,0.3)'/>
    </filter>
  </defs>
  <g filter='url(#s)'>
    <path d='M17 2C9 2 3 8 3 16c0 11 14 26 14 26s14-15 14-26c0-8-6-14-14-14z' fill='${color}'/>
    <circle cx='17' cy='16' r='6' fill='white'/>
  </g>
</svg>`);
  return L.divIcon({
    className: `bb-marker ${pulse ? "bb-pulse-ring" : ""}`,
    html: `<img src="data:image/svg+xml;utf8,${svg}" width="34" height="44"/>`,
    iconSize: [34, 44],
    iconAnchor: [17, 42],
    popupAnchor: [0, -38],
  });
}

export const athleteIcon = makeIcon("#FF6B4A");
export const ballboyIcon = makeIcon("#0F8A8A");
export const liveIcon = makeIcon("#0EA5E9", true);

function ClickCapture({ onPick }) {
  useMapEvents({
    click(e) {
      if (onPick) onPick({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

export function MapCard({
  center = [40.758, -73.9855],
  zoom = 13,
  height = 260,
  pickable = false,
  onPick,
  pins = [], // [{lat,lng,variant,label}]
  radiusMeters,
  className = "",
  children,
  testId = "map-card",
}) {
  const iconFor = useMemo(
    () => ({ athlete: athleteIcon, ballboy: ballboyIcon, live: liveIcon }),
    []
  );
  return (
    <div
      className={`rounded-2xl overflow-hidden border border-border shadow-[var(--bb-shadow-sm)] ${className}`}
      style={{ height }}
      data-testid={testId}
    >
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='© OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {radiusMeters && pins[0] && (
          <Circle
            center={[pins[0].lat, pins[0].lng]}
            radius={radiusMeters}
            pathOptions={{ color: "#0F8A8A", fillColor: "#0F8A8A", fillOpacity: 0.08, weight: 1 }}
          />
        )}
        {pins.map((p, i) => (
          <Marker
            key={i}
            position={[p.lat, p.lng]}
            icon={iconFor[p.variant || "ballboy"]}
          >
            {p.label && <Popup>{p.label}</Popup>}
          </Marker>
        ))}
        {pickable && <ClickCapture onPick={onPick} />}
        {children}
      </MapContainer>
    </div>
  );
}
